import { render, staticRenderFns } from "./matrixDetail.vue?vue&type=template&id=3c2359b9&scoped=true"
import script from "./matrixDetail.vue?vue&type=script&lang=js"
export * from "./matrixDetail.vue?vue&type=script&lang=js"
import style0 from "./matrixDetail.vue?vue&type=style&index=0&id=3c2359b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2359b9",
  null
  
)

export default component.exports